import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import DropdownList from 'react-widgets/lib/DropdownList';
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

import { getDepartmentId, getDistrictId, getMonthBonusState } from '../selectors';
import { dispatchDistrict, dispatchDepartment, setBonusMonth, setMonthBonusState } from '../actions';
import { UNAPPROVED, APPROVED, FINALIZED } from '../constants';

import BonusPeriodEnhanced from './BonusPeriodEnhanced';
import DistrictFilter from '../../fields/DistrictFilter';
import DepartmentFilter from '../../fields/DepartmentFilter';
import { queryGetAllBonusMonthsGQL } from '../../bonuses/graphql/allBonusMonthApi';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  currentDistrictId: PropTypes.number,
  dispatchDistrictAction: PropTypes.func.isRequired,

  currentDepartmentId: PropTypes.number,
  dispatchDepartmentAction: PropTypes.func.isRequired,

  allBonusMonths: PropTypes.array.isRequired,
  setBonusMonthAction: PropTypes.func.isRequired,

  monthBonusState: PropTypes.string.isRequired,
  setMonthBonusStateAction: PropTypes.func.isRequired,
});
/* eslint-enable react/no-unused-prop-types */

const bonusStateList = [
  { name: UNAPPROVED, value: UNAPPROVED },
  { name: APPROVED, value: APPROVED },
  { name: FINALIZED, value: FINALIZED },
];

const FiltersPanel = (props) => {
  const { currentDistrictId, dispatchDistrictAction,
    dispatchDepartmentAction, currentDepartmentId } = props;

  const { allBonusMonths } = props;
  const { setMonthBonusStateAction, monthBonusState } = props;

  const handleSelectMonthBonusState = (e) => {
    const { value } = e;
    setMonthBonusStateAction(value);
  };

  return (
    <div>
      <FormGroup>
        <ControlLabel className="control-label">
          Monthly Bonus State:
        </ControlLabel>
        <DropdownList
          inputProps={{
            className: 'form-control',
          }}
          data={bonusStateList}
          filter="contains"
          valueField="value"
          textField="name"
          value={monthBonusState}
          onChange={(e) => { return handleSelectMonthBonusState(e); }}
        />

      </FormGroup>
      <FormGroup>
        <ControlLabel className="control-label">
          Bonus Period:
        </ControlLabel>
        <BonusPeriodEnhanced allBonusMonths={allBonusMonths} />
      </FormGroup>
      <FormGroup>
        <ControlLabel className="control-label">
          District:
        </ControlLabel>
        <DistrictFilter
          name="Field District"
          value={{ id: currentDistrictId }}
          onChange={dispatchDistrictAction}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel className="control-label">
          Department:
        </ControlLabel>
        <DepartmentFilter
          name="Department"
          value={{ id: currentDepartmentId }}
          onChange={dispatchDepartmentAction}
        />
      </FormGroup>
    </div>
  );
};


FiltersPanel.propTypes = propTypes;


const mapStateToProps = (state) => {
  return {
    currentDistrictId: getDistrictId(state),
    currentDepartmentId: getDepartmentId(state),
    monthBonusState: getMonthBonusState(state),
  };
};

const mapDispatchToProps = {
  dispatchDistrictAction: dispatchDistrict,
  dispatchDepartmentAction: dispatchDepartment,
  setBonusMonthAction: setBonusMonth,
  setMonthBonusStateAction: setMonthBonusState,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withInitPage = lifecycle({
  componentWillMount() {
    const {
      allBonusMonths, setBonusMonthAction,
    } = this.props;

    const latestMonthBonus = allBonusMonths[0].iso8601;
    setBonusMonthAction(latestMonthBonus);
  },
});


const enhance = compose(
  withRedux,
  queryGetAllBonusMonthsGQL,
  withInitPage,
);

export default enhance(FiltersPanel);
